var map = {
	"./music-instructions.json": 5292,
	"./music-library-intro2024.json": 5293,
	"./music-library-launch2024.json": 5294,
	"./music-progression.json": 5295,
	"./startSourcesAdvanced.json": 5296,
	"./startSourcesSimple.json": 5297,
	"./startSourcesSimple2.json": 5298,
	"./startSourcesTracks.json": 5299
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4898;